import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ProcedureActionImageView from './ProcedureActionImageView';

const ProcedureActionImageViewBridge = react2angular(ProcedureActionImageView, [
  'action',
  'headerIndex',
  'onClose',
  'onNavigateBackwards',
  'onNavigateForwards'
]);

export default ProcedureActionImageViewBridge;
